/**
 * `Clips.listByIds` rejects a longer id list with "Exceeded maximum number of clips (250)".
 * Artifact row pages use the same cap so one page is one request; a thread can still name more.
 */
export const CLIPS_LIST_BY_IDS_MAX_IDS = 250;

/** Splits ids into lists the clips lookup will accept. Order is preserved. */
export const chunkWorkspaceAgentClipIds = (clipIds: readonly string[]): string[][] => {
  if (clipIds.length === 0) {
    return [];
  }

  const chunks: string[][] = [];

  for (let start = 0; start < clipIds.length; start += CLIPS_LIST_BY_IDS_MAX_IDS) {
    chunks.push(clipIds.slice(start, start + CLIPS_LIST_BY_IDS_MAX_IDS));
  }

  return chunks;
};
